export const CONFIGURATION_GRID_CODE = 'new-vehicle-configuration';
